// CompanyCategoryMatchPanel — 상품 관리 오른쪽 칸 "회사에 붙이기".
//   회사마다 ① 어떤 분류를 쓸지 ② 일일콜현황에 카테고리를 고정할지 상품을 고르게 할지 를 정한다.
//   동적 관리 > 영업 운영 > 회사별 일일콜 표시를 여기로 옮겼다(2026-09-20 사용자 확정).
import React from 'react';
import {
  input, addBtn, panelCard, panelHead, panelBody, companyCard,
  companyName, companyCode as companyCodeStyle, hintText, warnText, modePill,
  fieldLabel, cardDivider, saveRow,
} from './productStyles';

export function CompanyCategoryMatchPanel({ match, options }) {
  const { rows, loading, savingCode, allowed, setField, viewOf, save } = match;
  if (!allowed) return null;

  // options: [{ name, count }] — 왼쪽 칸에서 만든 분류들. 고르면 목록이 빌 분류를 미리 보여준다.
  const optionNames = options.map((o) => o.name);

  return (
    <div style={panelCard}>
      <div style={panelHead}>
        <span>회사에 붙이기</span>
        <span style={{ fontSize: 11, fontWeight: 700, opacity: 0.7 }}>{rows.length}개 회사</span>
      </div>
      <div style={panelBody}>
        {loading && <div style={hintText}>불러오는 중…</div>}
        {!loading && rows.length === 0 && <div style={hintText}>연결할 회사가 없습니다.</div>}
        {!loading && rows.map((row) => {
          const v = viewOf(row);
          // 저장된 값이 지금 분류 목록에 없으면 조용히 "선택 안 함"으로 보이면 안 된다 — 깨진 걸 숨기게 된다.
          const orphan = Boolean(v.value) && !optionNames.includes(v.value);
          const picked = options.find((o) => o.name === v.value);
          return (
            <div key={row.code} style={companyCard}>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, flexWrap: 'wrap' }}>
                <span style={companyName}>{row.name}</span>
                <span style={companyCodeStyle}>{row.code}</span>
                {row.is_primary && <span style={companyCodeStyle}>· 본사</span>}
                {!row.call_enabled && <span style={hintText}>· 일일콜 기능 꺼짐</span>}
              </div>

              {/* 저장 버튼은 **맨 아래 한 줄**에 둔다 (2026-09-20 사용자 지적).
                  전에는 분류 옆에 있어서, 그 아래 표시방식은 누르면 바로 적용되는 것처럼 보였다. */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                <span style={fieldLabel}>분류</span>
                <select style={{ ...input, minWidth: 150 }} value={v.value}
                  onChange={(e) => setField(row.code, 'value', e.target.value)}>
                  <option value="">선택 안 함</option>
                  {orphan && <option value={v.value}>{v.value} (없는 분류)</option>}
                  {options.map((o) => (
                    <option key={o.name} value={o.name}>{o.name} · 상품 {o.count}개</option>
                  ))}
                </select>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                <span style={fieldLabel}>일일콜현황에</span>
                <button type="button" style={modePill(v.is_category)}
                  title="일일콜현황 상품칸에 분류 이름이 글자로 고정됩니다"
                  onClick={() => setField(row.code, 'is_category', true)}>카테고리 고정</button>
                <button type="button" style={modePill(!v.is_category)}
                  title="그 분류에 속한 상품을 직원이 고릅니다"
                  onClick={() => setField(row.code, 'is_category', false)}>상품 고르기</button>
              </div>

              {orphan && <div style={warnText}>저장된 분류 "{v.value}" 가 지금 목록에 없습니다. 다시 골라 주세요.</div>}
              {!orphan && picked && picked.count === 0 && !v.is_category && (
                <div style={warnText}>이 분류에 상품이 없어 직원 화면 목록이 빕니다.</div>
              )}
              {row.inherited && !v.dirty && (
                <div style={hintText}>지금은 전체 기본값을 따라갑니다. 저장하면 이 회사에 고정됩니다.</div>
              )}

              <div style={cardDivider} />
              <div style={saveRow}>
                {v.dirty && <span style={{ ...hintText, alignSelf: 'center', marginRight: 8 }}>아직 저장 전입니다</span>}
                <button style={addBtn} disabled={savingCode === row.code} onClick={() => save(row.code)}>
                  {savingCode === row.code ? '저장 중…' : '저장'}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
